import { Injectable, Inject } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { ConfigurationActions } from '@actions/index';
import { PolicyActions, QueryActions } from '@actions/configuration/index';
import { OracleStorageService } from '@services/oracle-storage.service';
import { QueryModel } from '@models/configuration/query.model';


@Injectable()
export class QueryEffects {
    // Querys Effects
    searchQuerys$ = createEffect(() =>
        this.actions$.pipe(
            ofType(QueryActions.searchQueries),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .search$(action)
                    .pipe(
                        map((Queries: QueryModel[]) => QueryActions
                            .searchQueriesSuccess({ Queries })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),PolicyActions.resetLoading()))
                    )
            ))
    );

    searchQueryOne$ = createEffect(() =>
        this.actions$.pipe(
            ofType(QueryActions.searchQueryOne),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .searchOne$(action)
                    .pipe(
                        map((QueryOne: QueryModel[]) => QueryActions
                            .searchQueryOneSuccess({ QueryOne })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),PolicyActions.resetLoading()))
                    )
            ))
    );

    createQuerys$ = createEffect(() =>
        this.actions$.pipe(
            ofType(QueryActions.createQuery),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .create$(action)
                    .pipe(
                        map((Query: QueryModel) => QueryActions
                            .createQuerySuccess({ Query })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),PolicyActions.resetLoading()))
                    )
            ))
    );

    updateQuerys$ = createEffect(() =>
        this.actions$.pipe(
            ofType(QueryActions.updateQuery),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .update$(action)
                    .pipe(
                        map((Query: QueryModel) => QueryActions
                            .updateQuerySuccess({ Query })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),PolicyActions.resetLoading()))
                    )
            ))
    );

    deleteQuerys$ = createEffect(() =>
        this.actions$.pipe(
            ofType(QueryActions.deleteQuery),
            switchMap(({ action }) =>
                this.oracleStorageService
                    .delete$(action)
                    .pipe(
                        map((Query: QueryModel) => QueryActions
                            .deleteQuerySuccess({ Query })
                        ),
                        catchError(error => of(ConfigurationActions.configurationError({ error }),PolicyActions.resetLoading()))
                    )
            ))
    );
    
    constructor(
        private actions$: Actions,
        @Inject('OracleStorageService') private oracleStorageService: OracleStorageService<QueryModel>,
    ) { }
}